"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var types_1 = require("./types");

var defaultOptions = {
  method: types_1.HTTPMethod.get,
  cache: types_1.FetchOptionCache.default,
  redirect: types_1.FetchOptionRedirect.follow,
  credentials: types_1.FetchOptionCredentials.sameOrigin,
  mode: types_1.FetchOptionMode.sameOrigin,
  referrer: types_1.FetchOptionReferrer.client
};

function setDefaultOptions(options) {
  return Object.assign(defaultOptions, options);
}

exports.setDefaultOptions = setDefaultOptions;

function getDefaultOptions() {
  return defaultOptions;
}

exports.getDefaultOptions = getDefaultOptions;